let _en={};

_en["link"]={
    "enter.otp":"Enter OTP sent to mobile number",
    "otp.not.received":"OTP not received?  ",
    "blank.otp":"OTP can not be blank",
    "request.otp":"Request another OTP",
    "enter.mobile.number":"Enter your Mobile Number",
    "enter.amount":"Enter Amount",
    "enter.desc":"Description (Optional)",
    "desc.limit.error":"Description should be from 3 to 30 characters",
    "verify.mobile.number":"Verify Mobile Number",
    "will.send.otp":"We will send an OTP to this number",
    "change.number":"Change Number",
    "otp.sent":"OTP sent to mobile no.",
    "otp.verify":"Verify",
    "invalid.amount":"Invalid amount",
    "add.desc":"+ Add Description",
    "limit.reached.otp":"Oops ! You have reached OTP limit, please raise a query at paytm.com/care.",
    "amount.to.paid":"Amount to be paid",
    "pay":"PAY",
    "desc.max.min.error":"Description should be from 3 to 30 characters",
    "invalid.desc":"Description should not contain any special characters",
    "payment.details":"Payment Details",
    "total.amount":"Total Amount",
    "paid.till.date":"Paid Till Date",
    "balance.payable":"Balance Payable"
}

_en["form"]={
    "required.error":"is required",
    "not.valid.value":"The entered value is not valid",
    "not.allowed.value":"The entered value is not allowed",
    "can.be.from":"can be from",
    "to":"to",
    "character":"characters",
    "can.be.between":"can be between",
    "and":"and",
    "fixed.length":"length must be",
    "payment.details":"Payment Details",
    "block.amt.heading":"Processing Payment",
    "block.amt.text":"The amount will be adjusted once payment is confirmed",
    "payment.history":"Payment History",
    "select.pay":"Choose amount to pay",
    "pay.full":"Pay full amount",
    "pay.partial":"Pay partial amount",
    "paid.on":"Paid on"
}
_en["invoice"]={
    "expired.on":"Expired on",
    "already.paid":"Invoice already Paid",
    "billing.date":"Billing Date",
    "invoice.details":"INVOICE DETAILS",
    "invoice.id":"Invoice ID",
    "amount.to.paid":"AMOUNT TO BE PAID",
    "desc":"Description",
    "expiry.date":"Expiry Date",
    "customer.details":"CUSTOMER DETAILS",
    "name":"Name",
    "email":"Email",
    "phone.no":"Phone No.",
    "not.mentioned":"Not Mentioned",
    "billing.details":"BILLING DETAILS",
    "sno":"SNo.",
    "item.name":"Item Name",
    "item":'Item',
    "qty":"Qty",
    "units":"Units",
    "price.per.unit":"Price per Unit",
    "tax":"Tax",
    "amount":"Amount",
    "total.amount":"Total Amount",
    "contact.merchant":"Contact Merchant",
    "download.invoice":"Download Invoice",
    "print.invoice":"Print Invoice",
    "ok.got.it":"OK Got it!"
}

_en["button"]={
    "proceed.to.pay":"Proceed to Pay",
    "pay": "Pay",
    "pay.post.text": "to Register Autopay",
    "add":"Add",
    "remove":"Remove"
}
_en["error"]={
    "something.went.wrong":"Something went wrong. Please try again later",
    "partial.amount.max":"Amount entered cannot be greater than the payable amount"
}

_en["footer"]={
    "visit.payment.link":"To create Payment Links, visit",
    "visit.payment.invoice":"To create Payment Invoices, visit"
}
_en["subscription"]={
    "name":"Name",
    "email":"Email",
    "mobile":"Mobile",
    "subscription.at":"Your Subscription at",
    "subscription.for":"subscription for",
    "subscription.details":"subscription details",
    "your.subs":"Your Subscription at",
    "plan.desc":"Plan Name and Description",
    "plan.amount":"Plan Amount",
    "next.bill":"Next Billing Date:",
    "valid.till":"Subscription Valid Till",
    "first.payment":"FIRST PAYMENT",
    "next.payment":"NEXT PAYMENTS",
    "footer.text":"100% Secure Payments Powered by Paytm",
    "upto":'upto',
    "pay.info":"IMPORTANT: Please ensure that you only pay to merchants you already know. Never make a payment to a non-trusted merchant for offers or prizes as it may be a scam",
    "next.on.demand":"Upto \u20b9$amount will be charged until the subscription is valid",
    "next.fixed.interval":"$frequency after the first payment upto \u20b9$amount will be charged until the subscription is valid",
    "first.amount":"Amount",
    "inclusive":"(inclusive of one time charge)",
    "first.payment":"FIRST PAYMENT",
    "next.payment":"NEXT PAYMENT",
    "upto.min": "upto \u20b9$amount may be deducted from your bank",
    "is.active":"Your subscription is active.",
    "trial.period":"TRIAL PERIOD",
    "trial.text":"$time day trial period",
    "DAY":" Per Day",
    "MONTH":" Per Month",
    "YEAR":" Per Year",
    "WEEK":" Per Week",
    "QUARTER":" Every Quarter",
    "BI_MONTHLY":" Every 2 Months",
    "SEMI_ANNUALLY":" Every Half-year",
    "FORTNIGHT":" Every Fortnight",
    "show.more":"Show more",
    "merchant.name":"Merchant name",
    "confirm.cancel":"Confirm Cancellation",
    "cancel.warning":"If you cancel now, you can still access your subscription till",
    "cancel.msg":"You can still access your subscription till",
    "got.it":"Ok. got it",
    "proceed.cancel":"Proceed to Cancel",
    "cancelled":"Your Subscription has been cancelled",
    "not.now":"Not Now",
    "mobile.number":"Mobile Number",
    "update":"Update",
    "update.mobile":"Update Mobile No.",
    "verify.mobile":"Verify Mobile Number",
    "enter.otp.mobile":"Enter OTP sent to mobile no.",
    "confirm":"Confirm",
    "failed.to.send":"Failed to resend OTP. No attempts left!",
    "otp.resent":"OTP resent Successfully.",
    "left.attempt":"attempt left",
    "contact":"Contact Merchant",
    "pay.history":"Payment History",
    "cancel":"Cancel Subscription",
    "invalid.otp":"Please enter a valid OTP",
    "email.id":"Email ID",
    "update.email":"Update Email ID",
    "contact.merchant":"Contact Merchant",
    "enter.mobile.number":"Please enter your mobile number",
    "enter.valid.mobile":"Please enter a valid mobile number",
    "enter.email":"Please enter your email id",
    "enter.valid.email":"Please enter a valid email id",
    "processing":"Processing",
    "failed":"Failed",
    "paid":"Paid",
    "is.cancelled":"Your subscription is cancelled.",
    "cancel.date":"Cancelled date is",
    "is.expired":"Your subscription is expired.",
    "expiry.date":"Expired on",
    "is.closed":"Your subscription is closed.",
    "authorization.failed": "Your subscription is not authorized.",
    authorized: "Your subscription is authorized.",
    suspended: "Your subscription is paused.",
    "close.date":"Closed on",
    "susbs.cancel": "Are you sure you want to cancel the subscription?"
} 

_en["paymentDetails"] = {
    "amt.to.be.paid" : "Amount to be paid",
    "total.amt" : "Total link amount",
    "amt.paid.till.date" : "Amount paid till date",
    "blocked.amt" : "Payment under process",
    "payable.amt" : "Balance payable",
    "link.valid.till" : "This link is valid till",
    "merchant.ref" : "Merchant reference ID"
}

export default _en;


// WEBPACK FOOTER //
// ../locale/en.js